import type { ReactNode } from 'react'

import { Container } from './Container'

type Props = {
	children: ReactNode
}

export const Page = ({ children }: Props) => (
	<Container>
		<main>{children}</main>
	</Container>
)
